import { render, staticRenderFns } from "./fashion.vue?vue&type=template&id=3e518e2c&scoped=true&"
import script from "./fashion.vue?vue&type=script&lang=js&"
export * from "./fashion.vue?vue&type=script&lang=js&"
import style0 from "./fashion.vue?vue&type=style&index=0&id=3e518e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e518e2c",
  null
  
)

export default component.exports